import { useMutation } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import capitalMarketsService from '../services/capitalMarketsService';

export default function useDownloadCessionCsv() {
  return useMutation({
    mutationFn: (cessionId: number) => capitalMarketsService.downloadCessionCsv(cessionId),
    onError: (error: any) => {
      const status = error?.response?.status;

      const errorMessage = status === 404
        ? 'Cessão não encontrada.'
        : 'Erro ao gerar relatório CSV';

      toast.error(errorMessage);
    },
    onSuccess: ({ data, filename }: { data: Blob; filename: string }) => {
      const blobUrl = window.URL.createObjectURL(data);
      const link = document.createElement('a');

      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

      toast.success('Relatório CSV baixado com sucesso');
    },
    retry: false,
  });
}
